import type { MemberAssociationResponse } from "@finn-no/mobility-dealer-types";
import { useSafeDealerItemContext } from "@mobility-item-page/dealer/client";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import type { SafetyTabs } from "src/types/safetyElements.ts";
import SafetyElementsDesktop from "./Desktop.tsx";
import SafetyElementsMobile from "./Mobile.tsx";

export type SafetyElementsProps = {
  safetyElements?: SafetyTabs[];
  memberAssociations?: MemberAssociationResponse[];
};
const SafetyElements = ({ safetyElements }: SafetyElementsProps) => {
  const dealerItemContext = useSafeDealerItemContext();
  const { isMobile } = useAppConfig();

  const SafetyElements = isMobile ? SafetyElementsMobile : SafetyElementsDesktop;

  return <SafetyElements safetyElements={safetyElements} memberAssociations={dealerItemContext?.memberAssociations} />;
};

export default SafetyElements;
